import React, {useEffect,useState} from "react";
import "./CategoryRegalV3.scss";
import SwiperId from "react-id-swiper";
import {useHistory} from "react-router-dom";
import {useBasket, useDispatchBasket} from "../../hooks";
import {BasketAddRemove} from "..";
import {
    getCats_api,
    getMallCats_api,
    getProductsCategory_api,
    getProductsMall_api,
    getSampleProduct_api
} from "../../Services/apis";
import {convertRialToToman, convertVariantTypeNameWithVal, getMallColor} from "../../Services";
import {AddBasket, RemoveBasket} from "../OnlineAddress/OnlineAddressService";
import {message} from "antd";
import SwiperCore,{Autoplay, Pagination, Navigation } from "swiper";

// let merchantRegal = ""
// let catRegal = ""

const imageParamss = {
    slidesPerView: 'auto',
    spaceBetween: 40,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false
    },
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
}


const catParams = {
    slidesPerView: 'auto',
    spaceBetween: 10,
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
}

function BasketAddRemoveSub({product,handleChangeProduct,changeOut}) {

    //hooks
    const setBasket = useDispatchBasket();
    const basket = useBasket();
    const history = useHistory();

    //states
    const [loading, set_loading] = useState(false)
    const [base, set_base] = useState(product)
    const [item, set_item] = useState(null)
    const [merchantId,set_merchantId] = useState(product.merchant.uid)


    useEffect(() => {
        if(product?.variants?.length > 0) {
            set_item(product.variants[0])
        }else{
            set_item(product)
        }
    }, [])

    const addToBasket = async (pId) => {
        const response = await AddBasket(merchantId, pId,item)
        console.log("Add : ", response)
    }

    const removeFromBasket = async (pId) => {
        const response = await RemoveBasket(merchantId, pId)
        console.log("Remove : ", response)
    }

    //functions
    const inc = async () => {
        console.log("ssssssssssssssssssss")
        if (loading) {
            return
        }


        let pickCount = basket.find(p=>p.product.uid===product.uid)

        if(pickCount && product.stock<pickCount.count+1){
            return message.error('درخواست شما بیشتر از سقف موجودی است');
        }

        if(pickCount && product.order_cap<pickCount.count+1){
            return message.error('درخواست شما بیشتر از سقف خرید است');
        }

        try {
            set_loading(true)
            //ADD API
            await addToBasket(item.uid);
            set_loading(false)
        } catch (e) {
            set_loading(false)
            return;
        }
        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        if (basket.find(product => product.product.uid === item.uid)) {
            //exist
            let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count: pro.count + 1} : pro)
            //context change
            setBasket(filter);
            //storage change
            localStorage.setItem("basket", JSON.stringify(filter));
        } else {
            //not exist

            //context change
            setBasket(oldArray => [...oldArray, {product: item, count: 1}]);
            //storage change
            localStorage.setItem("basket", JSON.stringify([...basket, {product: item, count: 1}]));
        }


    }

    const dec = async () => {
        if (loading) {
            return
        }
        try {
            set_loading(true)
            //Remove API
            await removeFromBasket(item.uid)
            set_loading(false)
        } catch (e) {
            set_loading(false)
            return;
        }

        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        let find = basket.find(product => product.product.uid === item.uid);
        if (find) {
            //exist
            if (find.count > 0) {
                //exist
                let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count: pro.count - 1} : pro)

                if (find.count === 1) {
                    //context change
                    setBasket(basket.filter(product => product.product.uid !== item.uid))
                    //storage change
                    localStorage.setItem("basket", JSON.stringify(basket.filter(product => product.product.uid !== item.uid)));
                } else {
                    //context change
                    setBasket(filter);
                    //storage change
                    localStorage.setItem("basket", JSON.stringify(filter));
                }
            } else {
                //context change
                setBasket(basket.filter(product => product.product.uid !== item.uid))
                //storage change
                localStorage.setItem("basket", JSON.stringify(basket.filter(product => product.product.uid !== item.uid)));
            }
        }


    }

    const remove = () => {
        //--------------------------------- Context Change ----------------------------------------------
        setBasket(basket.filter(product => product.product.uid !== item.uid))
        //--------------------------------- Local Storage Change ----------------------------------------------
        setTimeout(() => {
            localStorage.setItem("basket", JSON.stringify(basket));
        }, 500)
    }

    const checkCount = () => {
        if(!item)
            return 0

        let basket_count = basket.find(product => product.product.uid === item.uid);
        if (basket_count) {
            return basket_count.count;
        }
        return 0;
    }

    const handleVariantChange = (vId)=>{
        const  find = base.variants.find(v=>v.uid===vId)
        console.log("find : ",find)
        set_item(find)
        handleChangeProduct(find)
    }


    useEffect(()=>{
        set_item(changeOut)
    },[changeOut])

    return (
        <div>
            {/*{base?.variants?.length > 0 ?*/}
            {/*    <div className="var-section">*/}
            {/*        <select*/}
            {/*            onChange={e=>{*/}
            {/*                handleVariantChange(e.target.value)*/}
            {/*            }}*/}
            {/*            name="" id="">*/}
            {/*            {base.variants.map(v=>{*/}
            {/*                return(*/}
            {/*                    <option value={v.uid}>{convertVariantTypeNameWithVal(v.variant_type,v.variant_attr)}</option>*/}
            {/*                )*/}
            {/*            })}*/}
            {/*        </select>*/}
            {/*    </div>:*/}
            {/*    null*/}
            {/*}*/}

            {item && checkCount() > 0?<div className="dr-shop-add-remove-v2-change">
                {item && checkCount() > 0 ? <>
                    <i className="clickable fa fa-minus" onClick={dec}></i>
                    <span className="plusIcon product-count-number-v2">{!loading ? checkCount() : <i className="fa fa-spinner fa-spin"></i>}</span>
                </> : null}
                {item.stock>checkCount()?
                    <i className="clickable fa fa-plus" onClick={inc}></i>:
                    <span></span>
                }

            </div>:null}

            {item && checkCount() < 1?<div>
                {!loading?<i className="clickable plusIcon fa fa-plus" onClick={inc}></i>:
                    <i className="plusIcon fa fa-spinner fa-spin"></i>
                }


            </div>:null}


        </div>
    )
}



function numberWithCommas  (x) {
    if (x === 0) {
        return 0
    }
    if(x){
        x= Math.round(x)
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    return "-"

}

function limitText(txt,length) {
    if(txt.length>length){
        return txt.substr(0,length)+" ... "
    }else {
        return txt
    }
}

function ProCardMobile({product}){
    const history = useHistory()

    const [p,set_p] = useState(product)

    const goToProductDetail = ()=>{
        if(product.variants && product.variants.length > 0)
            history.push(`/dr-shop/detail/${product.merchant.uid}/${product.uid}`,{variant: p})
        else
            history.push(`/dr-shop/detail/${product.merchant.uid}/${product.uid}`)

    }

    useEffect(()=>{
        if(product.variants && product.variants.length>0){
            set_p({...product.variants[0],merchant:product.merchant})
        }else{
            set_p(product)
        }
    },[])

    const handleChangeProduct = (pr)=>{
        console.log("product : ",pr)
        set_p(pr)
    }
    const handleChangeVar = (vId)=>{
        let find = product.variants.find(v=>v.uid===vId)
        set_p({...find,merchant:product.merchant})
    }

    return(

        <>
            <div className="swiper-card-body" >
                {/*<BasketAddRemove i={i}/>*/}
                <div className="swiper-card-body-image" onClick={e=>{
                    goToProductDetail()
                }}>
                    {p.stock===0?<div className="notExist-badge">ناموجود</div>:null}
                    <img src={p.image} alt=""/>
                </div>
            </div>
            <div className="price-section" onClick={()=>{
                goToProductDetail()
            }}>
                <div className="price">
                    {numberWithCommas(p.price/10)} تومان
                </div>
                {p.price_original-p.price>0?<div className="price-without-off">
                    {numberWithCommas(p.price_original/10)}
                </div>:null}
            </div>
            {/*{i && p.discount_percentage!==0?*/}
            {/*    <div className="off">*/}
            {/*        <span>{p.discount_percentage+" % "}</span>*/}
            {/*    </div>:null*/}
            {/*}*/}
            <div className="info-section">
                {product.variants.length>1?
                    <select
                        className="var-select-mobile"
                        onChange={e=>{
                            handleChangeVar(e.target.value)
                        }}
                        name="" id="">
                        {product.variants.map(v=>{
                            if(v.is_active){
                                return(
                                    <option value={v.uid}>{convertVariantTypeNameWithVal(v.variant_type,v.variant_attr)}</option>
                                )
                            }
                        })}
                    </select>:null
                }

                <div className="name">{limitText(p.name,25)}</div>
                {/*<div className="weight">1500 گرمی میهن</div>*/}
            </div>

            <div className="add-section">
                <BasketAddRemoveSub product={p} changeOut={p}/>
            </div>
            </>
    )
}

function CategoryRegalV3({item,sort=false}) {
    SwiperCore.use([Autoplay])
    //hooks
    const history = useHistory();

    const [cats,set_cats] = useState([]);
    const [selectedCat,set_selectedCat] = useState(null);
    const [products,set_products] = useState([]);
    const [cat_banner,set_cat_banner] = useState("")
    const [cat_name,set_cat_name] = useState("")
    const [spin,set_spin] = useState(false)
    const [regalFlag,set_regalFlag] = useState(true)

    const [mallPrimaryColor, set_mallPrimaryColor] = useState('');
    const [mallSecondaryColor, set_mallSecondaryColor] = useState('');

    useEffect(()=>{
        let {primary, secondary} = getMallColor()
        set_mallPrimaryColor(primary)
        set_mallSecondaryColor(secondary)
    },[])

    useEffect(()=>{
        set_cats(item.items)
        if(item.items.length>0)
            initCats(item.items[item.items.length-1])
    },[])

    const initCats = (cat)=>{
        set_selectedCat(cat)
        getCat(cat)
    }

    const handleSelectCat = (c)=>{
        console.log(c)
        set_selectedCat(c)
        getCat(c)
    }

    const getCat = async (cat)=>{
        set_spin(true)
        let merchantId = cat.text
        let catId = cat.link_to_uid
        try{
                const res = await getProductsCategory_api(merchantId, catId)
            set_cat_banner(res.category_image)
            set_cat_name(res.category_name)
            set_products([])
            set_products(res.results)
            set_regalFlag(false)
            set_regalFlag(true)
            set_spin(false)
        }catch (e) {
            set_spin(false)
            console.log(e)
        }
    }

    const seeMoreProduct = ()=>{
        let merchantId = selectedCat.text
        let catId = selectedCat.link_to_uid
        history.push(`/dr-shop/search/${merchantId}/${catId}`)
    }


    return(
        // <span>swiper ...</span>
        <div style={{margin: "20px 16px 0 16px",borderRadius:10,padding:"10px",backgroundColor:selectedCat?.subtitle}} className="parent-regal">

            {cats && cats.length>0?
            <SwiperId {...catParams} >
                {cats.map(d=>{
                    return(
                        <div
                            className={selectedCat?.uid===d.uid?"swiper-card-container cat-slide active-item":"swiper-card-container cat-slide"}
                             onClick={e=>{
                            handleSelectCat(d)
                        }}>
                            <span>{d.title}</span>
                        </div>
                    )
                })}

            </SwiperId>:null}

            {regalFlag?<div className="online-off-section" style={{
                backgroundColor:selectedCat?.subtitle,
                margin: "10px 0",
                padding: 8,
            }}>
                {products && products.length>0? <SwiperId {...imageParamss}>
                    <div className="swiper-card-container product-n-cardi"  style={{backgroundColor:"transparent",marginLeft:20}}>
                        <div className="swiper-card-body" >
                            {/*<span>{item.title?item.title:"محصولات ویژه"}</span>*/}
                            <img src={selectedCat?.image} alt=""/>

                            <div className="regal-sort-sec">
                                <span className="see-more-in-card clickable" onClick={seeMoreProduct} style={{backgroundColor:"white !important"}}>مشاهده همه</span>
                                {/*<select*/}
                                {/*    value={sortSelect}*/}
                                {/*    onChange={e=>{handleChangeSort(e.target.value)}}*/}
                                {/*    name="" id="">*/}
                                {/*    <option value="-discounts"> بیشترین تخفیف</option>*/}
                                {/*    <option value="-sell">پر فروش ترین</option>*/}
                                {/*</select>*/}
                            </div>

                        </div>
                    </div>
                    {products.map(i=>{
                        return(
                            <div style={{width:100}}>
                                <div className="swiper-card-container" style={{
                                    boxShadow:"1px 1px 4px #f3f3f3"
                                }}>
                                    <ProCardMobile product={i}/>
                                </div>
                            </div>
                        )
                    })}
                    {/*<div className="swiper-card-container product-cardi" style={{backgroundColor:color}}>*/}
                    {/*    <div className="swiper-card-body">*/}
                    {/*        <div className="swiper-more-card">*/}
                    {/*            <span>مشاهده محصولات </span>*/}
                    {/*            <span onClick={seeMoreProduct} className="swiper-more-card-btn">بیشتر</span>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className="swiper-card-container product-cardi" style={{backgroundColor:selectedCat?.subtitle}}>
                        <div className="swiper-card-body">
                            <span></span>
                        </div>
                    </div>
                </SwiperId>:null}
            </div>:null}
            {/*<div className="more-section-mobile">*/}
            {/*    <span onClick={seeMoreProduct} style={{backgroundColor:mallPrimaryColor}}>مشاهده همه</span>*/}
            {/*</div>*/}
        </div>

    )
}

export {CategoryRegalV3};
